import { HeartPulse } from 'lucide-react';
import type { EmergencyContact, EmergencyInfo } from '@app/shared';
import type { SearchResult, WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';

export const emergencyModule: WebModule = {
  id: 'emergency',
  label: 'Emergency',
  icon: HeartPulse,
  path: '/emergency',
  nav: { group: 'household', order: 5 },
  // Like every screen, its code is precached by the service worker, so it opens offline.
  routes: [{ path: 'emergency', lazy: async () => ({ Component: (await import('./EmergencyScreen.tsx')).EmergencyScreen }) }],
  async search(q, ctx) {
    const out: SearchResult[] = [];
    for (const c of await familyRecords<EmergencyContact>('emergency_contacts', ctx.familyId)) {
      const score = scoreText(q, [c.name, c.relationship, c.phone, c.notes]);
      if (score)
        out.push({
          key: `emergency_contacts:${c.id}`,
          title: c.name,
          subtitle: c.relationship || 'Emergency contact',
          to: '/emergency',
          group: 'Emergency',
          icon: HeartPulse,
          score,
        });
    }
    for (const i of await familyRecords<EmergencyInfo>('emergency_info', ctx.familyId)) {
      const score = scoreText(q, [i.label, i.details]);
      if (score)
        out.push({ key: `emergency_info:${i.id}`, title: i.label, subtitle: 'Emergency info', to: '/emergency', group: 'Emergency', icon: HeartPulse, score });
    }
    return out;
  },
};
